module.exports = __webpack_public_path__ + "img/icon_menu_logo_small.25987f23.png";